import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:bg-background-100 cursor-pointer"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          title={`${article.title} - aqdlt`}
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-500 text-background-50">
            {article.category === 'zonghe-fuwu' ? '综合服务' :
             article.category === 'jishu-zhichi' ? '技术支持' :
             article.category === 'shangwu-hezuo' ? '商务合作' :
             article.category === 'xingye-zixun' ? '行业资讯' :
             article.category === 'chanpin-dongtai' ? '产品动态' : '成功案例'}
          </span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span>{article.publishDate}</span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}